/**
 * Mixing to make content block looks like "Card" with bordered edges
 * which hides/displays depends on scroll position
 * @param refName
 * @param borderRadiusBase
 * @param checkSlots
 * @returns {{}}
 */
export default function(refName, borderRadiusBase = 10, checkSlots = true) {
  return {
    data() {
      return {
        ref: null,
        scrollPositionTop: null,
        scrollPositionBottom: null,
        slotTagName: null,

        // maximum border-radius to be applied
        // to top and bottom left
        borderRadiusBase: borderRadiusBase
      };
    },

    methods: {
      _onContentScroll(e) {
        this.scrollPositionTop = e.target.scrollTop;
        this.scrollPositionBottom =
          e.target.scrollHeight - this.scrollPositionTop;
      }
    },

    computed: {
      borderRadiusStyles() {
        const borderRadiusTop = this.borderRadiusBase - this.scrollPositionTop;
        const borderRadiusBottom =
          this.scrollPositionBottom -
          document.body.scrollHeight +
          this.borderRadiusBase;

        return {
          borderTopLeftRadius: borderRadiusTop > 0 ? `${borderRadiusTop}px` : 0,
          borderBottomLeftRadius:
            // to avoid making greater border-radius
            this.scrollPositionBottom === null
              ? `${this.borderRadiusBase}px`
              : borderRadiusBottom <= this.borderRadiusBase
              ? `${borderRadiusBottom}px`
              : 0
        };
      }
    },

    mounted() {
      this.ref = this.$refs[refName];
      this.ref.addEventListener("scroll", this._onContentScroll);
    },

    updated() {
      if (!checkSlots) {
        return;
      }

      const { default: defaultSlots } = this.$slots;

      // check for slots
      if (defaultSlots) {
        const { tag } = defaultSlots[0];

        if (this.slotTagName !== tag) {
          // reset scroll positions
          this.scrollPositionTop = null;
          this.scrollPositionBottom = null;

          this.slotTagName = tag;
        }
      }
    },

    beforeDestroy() {
      this.ref.removeEventListener("scroll", this._onContentScroll);
    }
  };
}
